import { DraftPayroll } from '@nxsys/types/models/payroll';

// NX-6289: the row's company allows emailing draft payslips. Hides the row's
// send icon, enables the bulk action, and filters what a bulk send sends.
export const isEmailDraftAllowed = (record: DraftPayroll): boolean =>
  !!record.companyRef?.isSendEmailDraftSelfBill;
